'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var HttpClient = require('@tunz/http');

const sharedMemory = {};
const HTTP_CLIENT = 'HTTP_CLIENT';
const set = (name, value) => {
    sharedMemory[name] = value;
};
const get = (name) => sharedMemory[name];
const getHttpClient = () => sharedMemory[HTTP_CLIENT] || HttpClient.Axios.default;
var SharedMemory = {};

exports.HTTP_CLIENT = HTTP_CLIENT;
exports["default"] = SharedMemory;
exports.get = get;
exports.getHttpClient = getHttpClient;
exports.set = set;
